# GraphQL fragment to get basic info about a lead stage
# within the sales automation environment.

fragment SalesAutomationStage on Stage {
    id
    name
    description
    position
    avatarUrl
    defaultConfidence
    overdueDuration {
        timespan
        unit
    }
    autocloseDuration {
        timespan
        unit
    }
    autocloseOutcome {
        id
    }
}
